<template>
<div class="chapter">
<div class="inner_page">
<section class="element element-container-single element-non-bodymatter element-type-none element-without-heading" id="uncategorized">
<div class="text" id="uncategorized-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center"><b>Together in one volume, two frighteningly hilarious Dan Shamble, Zombie P.I. adventures!</b></p>
</div>
</div>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center"><b>Slimy Underbelly</b></p>
</div>
</div>
<p class="first first-in-chapter first-full-width">There’s something fishy going on in the Unnatural Quarter. Bodies are floating face-down, the plumbing is backing up, and something smells rotten—even to a zombie detective like Dan Shamble. Diving into the slimy underbelly of a diabolical plot, Dan comes face-to-tentacles with an amphibious villain named Ah’Chulhu (to which the usual response is “Gesundheit!”). With his snap-happy gang of gator-guys—former pets flushed down the toilet—Ah’Chulhu wreaks havoc beneath the streets. While feuding weather wizards kick up storms and a gang of thieving lawn gnomes continues their reign of terror, Dan Shamble is running out of time—before the whole stinking city goes down the drain….</p>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center"><b>Tastes Like Chicken</b></p>
</div>
</div>
<p class="subsq">Shamble faces his most fowl case yet, when a flock of murderous feral chicken terrorizes the Unnatural Quarter. Also in the caseload, Shamble deals with the sinister spokesman for Monster Chow Industries, a spreading contamination that drives vampires berserk, a serial-killer demon from the Fifth Pit of Hell, a black-market blood gang led by the nefarious Ma Hemoglobin, a ghost fighting a hostile takeover of his blood bars…and a cute little vampire girl who may, or may not, be his daughter.</p>
<p class="subsq">With his ghost girlfriend Sheyenne, his bleeding-heart lawyer partner Robin, and his Best Human Friend Officer Toby McGoohan, Dan Shamble is back from the dead and back on the case. The feathers will fly as he goes face-to-beak with the evil peckers.</p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// book-description.vue?bf6787a2